<app-breadcrumb></app-breadcrumb>
<div class="row">
    <div class="col">
        <div class="card mb-0">
            <div class="card-header bg-transparent border-bottom">
                <div class="row">
                    <div class="col">
                        <div class="btn-group btn-group-sm">
                            <button type="button" class="btn btn-outline-secondary"
                                mwlCalendarPreviousView
                                [view]="viewType"
                                [(viewDate)]="viewDate"
                                (viewDateChange)="isOpenActiveDay = false">
                                이전
                            </button>
                            <button type="button" class="btn btn-outline-secondary"
                                mwlCalendarToday
                                [class.active]="checkToday(viewDate) === true"
                                [(viewDate)]="viewDate">
                                현재
                            </button>
                            <button type="button" class="btn btn-outline-secondary"
                                mwlCalendarNextView
                                [view]="viewType"
                                [(viewDate)]="viewDate"
                                (viewDateChange)="isOpenActiveDay = false">
                                다음
                            </button>
                        </div>
                    </div>
                    <!-- <div class="col-auto text-center d-flex justify-content-center align-items-center">
                        <h4 class="mb-0">{{viewDate | date:'yyyy-MM-dd'}}</h4>
                    </div> -->
                    <div class="col text-center">
                        <ymd-selector
                            [selectedDate]="parseDate(viewDate)"
                            (callbackDate)="callbackDateYmd($event)"></ymd-selector>
                    </div>
                    <div class="col text-right">
                        <div class="btn-group btn-group-sm">
                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="changeCheckDateAll(true)">
                                <i class="far fa-check-square fa-fw"></i>
                                전체선택
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="changeUnCheckDateAll(false)">
                                <i class="far fa-square fa-fw"></i>
                                전체해제
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body" #containerCalendar>
                <mwl-calendar-month-view
                    [viewDate]="viewDate"
                    [events]="events"
                    [refresh]="refresh"
                    [locale]="viewLocale"
                    [activeDayIsOpen]="isOpenActiveDay"
                    [cellTemplate]="customCellTemplate"
                    (beforeViewRender)="beforeMonthViewRender($event)"
                    (dayClicked)="clickDay($event.day)"
                    (eventClicked)="handleEvent('Clicked', $event.event)"
                    (eventTimesChanged)="eventTimesChanged($event)">
                </mwl-calendar-month-view>
            </div>
        </div>
    </div>
    <div class="col-auto">
        <div class="card mb-0">
            <div class="card-header bg-transparent">
                <div class="text-right">
                    <div class="btn-group btn-group-sm">
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="changeCheckCarAll(true)">
                            <i class="far fa-check-square fa-fw"></i>
                            전체선택
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-secondary"
                            (click)="changeCheckCarAll(false)">
                            <i class="far fa-square fa-fw"></i>
                            전체해제
                        </button>
                    </div>
                </div>
            </div>
            <div class="table-responsive overflow-auto" [style.height]="heightCalendar+'px'">
                <table class="table table-sm table-hover align-items-center mb-0">
                    <thead class="text-center text-nowrap">
                        <tr>
                            <th class="col-auto">선택</th>
                            <th class="col">차량번호</th>
                        </tr>
                    </thead>
                    <tbody class="text-nowrap">
                        <tr *ngFor="let carInfo of listCarInfo;let idx = index;" class="text-center">
                            <td>
                                <div class="d-flex align-items-center justify-content-center">
                                    <input type="checkbox"
                                        class=""
                                        [attr.id]="'customCheck-'+carInfo.dtgVin"
                                        [(ngModel)]="listCarInfo[idx].checked">
                                </div>
                            </td>
                            <td>
                                <div [attr.for]="'customCheck-'+carInfo.dtgVin" class="mb-0"
                                    (click)="clickCarNo(idx,!carInfo.checked)">
                                    {{carInfo.dtgCarNo}}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<div class="row mt-3">
    <div class="col">
        <div class="card mb-0">
            <div class="card-header bg-transparent">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-sm btn-secondary" (click)="clickFileDownload2()">
                            <i class="far fa-check-square fa-fw"></i>
                            제출파일 생성
                        </button>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-sm btn-secondary" (click)="clickDownloadZip()">
                            <i class="far fa-check-square fa-fw"></i>
                            전체 압축 다운로드
                        </button>
                    </div>
                </div>
            </div>
            <div class="table-responsive overflow-auto"
                [style.height]="heightCalendar+'px'">
                <table class="table table-hover align-items-center text-nowrap mb-0">
                    <thead>
                        <tr class="text-center">
                            <th class="col-auto">
                                날짜
                            </th>
                            <th class="col-auto">
                                차량번호
                            </th>
                            <th class="col">
                                파일명
                            </th>
                            <th class="col-auto">
                                다운로드
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of listTxtFile;let idx = index;">
                            <tr>
                                <td>
                                    {{item.regDt}}
                                </td>
                                <td>
                                    {{item.carNo}}
                                </td>
                                <td>
                                    {{item.filename}}
                                </td>
                                <td>
                                    <button type="button" class="btn btn-sm btn-outline-secondary"
                                        (click)="clickDownTxt(idx)">
                                        Text 파일 다운로드
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<ng-template #customCellTemplate let-day="day" let-locale="locale">
<div class="cal-cell-top">
    <div class="h-100 d-flex flex-column">
        <div class="p-2 flex-fill">
            <div class="form-check pl-0 d-flex justify-content-between align-items-center">
                <input type="checkbox" class=""
                    [attr.id]="'date-check-'+parseDate(day.date)"
                    [(ngModel)]="listDateChecked[parseDate(day.date)]"
                    (ngModelChange)="changeDateCheck($event,day.date)">
                <label class="mb-0 flex-grow-1 text-right"
                    role="button"
                    [attr.for]="'date-check-'+parseDate(day.date)">
                    <span class="cal-day-number m-0 badge badge-pill badge-lignt"
                        style="font-size: inherit;">
                        {{ day.date | calendarDate:'monthViewDayNumber':locale }}
                    </span>
                </label>
            </div>
        </div>
        <div class="px-2 pb-2 flex-fill">
            <ng-container *ngIf="getCountCarUsed(parseDate(day.date)) < 0">
                <span class="badge badge-pill">
                    &nbsp;
                </span>
            </ng-container>
            <ng-container *ngIf="getCountCarUsed(parseDate(day.date)) >= 0">
                <span class="badge badge-pill badge-secondary">
                    {{ getCountCarUsed(parseDate(day.date)) }}
                </span>
            </ng-container>
        </div>
    </div>
</div>
</ng-template>